/* RESPONSIBLE TEAM: team-automation-foundations */

import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import {
  AiAgentEventDataBuilder,
  type AiAgentEventData,
  type AiAgentEventDataWireFormat,
} from 'embercom/objects/inbox/ai-agent-event-data';

export enum AiAgentEventType {
  OtpEmailVerificationSuccessful = 'otp_email_verification_successful',
  OtpEmailVerificationFailed = 'otp_email_verification_failed',
  OtpEmailVerificationUnsuccessful = 'otp_email_verification_unsuccessful',
  OtpEmailAlreadyVerified = 'otp_email_already_verified',
  OtpEmailTriggeredForVerification = 'otp_email_triggered_for_verification',
  UsageLimitReached = 'usage_limit_reached',
  AiCategoriesEscalation = 'ai_categories_escalation',
  AiAgentIgnoringUserMessage = 'ai_agent_ignoring_user_message',
  AiCategoriesReasoning = 'ai_categories_reasoning',
  AiAgentWorkflowStarted = 'ai_agent_workflow_started',
  AiAgentWorkflowFinished = 'ai_agent_workflow_finished',
  AiAgentWorkflowFailed = 'ai_agent_workflow_failed',
  AiAgentWorkflowStopped = 'ai_agent_workflow_stopped',
  AiAgentUserUnauthenticated = 'ai_agent_user_unauthenticated',
  SdrRoutingDecision = 'sdr_routing_decision',
  SdrRecoveryEmailSent = 'sdr_recovery_email_sent',
  AiAgentSetAttributes = 'ai_agent_set_attributes',
  AiAgentTaskStepReasoning = 'ai_agent_task_step_reasoning',
  AiAgentConditionalEvaluation = 'ai_agent_conditional_evaluation',
  AiAgentContentRetrieval = 'ai_agent_content_retrieval',
  AiAgentSkippedSteps = 'ai_agent_skipped_steps',
  AiAgentCodeConditionError = 'ai_agent_code_condition_error',
  AiAgentGotoSection = 'ai_agent_goto_section',
  AiAgentEndSection = 'ai_agent_end_section',
  ImpersonatedUserDataUpdateNotice = 'impersonated_user_data_update_notice',
  AiAgentFollowUpScheduled = 'ai_agent_follow_up_scheduled',
  AiAgentCodeBlockStarted = 'ai_agent_code_block_started',
  AiAgentCodeBlockFinished = 'ai_agent_code_block_finished',
}

interface AiAgentEventWireFormat {
  ai_agent_event_type: AiAgentEventType;
  ai_agent_event_data: AiAgentEventDataWireFormat;
}

export default class AiAgentRenderableEvent implements RenderableData {
  readonly renderableType = RenderableType.AiAgentEvent;
  readonly eventType: AiAgentEventType;
  readonly eventData: AiAgentEventData;

  constructor(eventType: AiAgentEventType, eventData: AiAgentEventData) {
    this.eventType = eventType;
    this.eventData = eventData;
  }

  get creatingEntity() {
    return { type: EntityType.Bot, id: -1 };
  }

  static deserialize(json: AiAgentEventWireFormat): AiAgentRenderableEvent {
    return new AiAgentRenderableEvent(
      json.ai_agent_event_type,
      AiAgentEventDataBuilder.deserialize(json.ai_agent_event_data),
    );
  }
}
